import React from 'react';
import AnnouncementDF from '../components/SimulatorsComponents/DefualtSimulators/AnnouncementDF';

//= ========================================================================

const Sim_V01_announcement = ({
  globJSON,
  simPlatform,
  slideshowRefs = null,
}) => (
  <AnnouncementDF
    globJSON={globJSON}
    simPlatform={simPlatform}
    slideshowRefs={slideshowRefs}
  />
);

export default Sim_V01_announcement;
